import css from "./Style.module.css";
import FormOptions from "./FormOptions";
import Form from "../../Components/Form/Form";
import Utils from "../../Services/Utills";

function AddContactModal({ children }) {
  console.log(children);
  
  const { closeModal, firstname, lastname,name, email, phone } = children;
  console.log(name);
  
  const options = FormOptions;

  // Prefill values if provided
  options.Fields.find(f => f.name === "firstname").value = firstname || "";
  options.Fields.find(f => f.name === "lastname").value = lastname || "";
  options.Fields.find(f => f.name === "email").value = email || "";
  options.Fields.find(f => f.name === "phone").value = phone || "";

  const onSubmit = (e) => {
    const dt = Utils.FormObject(e);
    closeModal(dt);
  };

  return (
    <div className={css.AddVesselModal}>
      <Form onSubmit={onSubmit}>{options}</Form>
    </div>
  );
}

export default AddContactModal;
